<!--
  功能：裁剪图片
  作者：刘美琦
  邮箱：2480984971@qq.com
  时间：2021年09月16日 10:25:37
-->
<template>
    <div class="upload-img">
        <div class="operation">
            <button @click="close">取消</button>
            <button @click="realImg">预览</button>
            <button @click="upload">完成</button>
        </div>
        <vue-cropper
            class="crooper"
            ref="cropper"
            :img="option.img"
            :outputSize="option.outputSize"
            :outputType="option.outputType"
            :info="option.info"
            :canScale="option.canScale"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :full="option.full"
            :fixedBox="option.fixedBox"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :centerBox="option.centerBox"
            :height="option.height"
            :infoTrue="option.infoTrue"
            :maxImgSize="option.maxImgSize"
            :enlarge="option.enlarge"
            :mode="option.mode"
        >
        </vue-cropper>
        <div class="mask" v-if="show" @click="show = false">
            <img class="overlay_img" :src="base64_img" />
        </div>
    </div>
</template>
<script>
import { VueCropper } from "vue-cropper";
export default {
    // 组件名称
    name: "Cutting",
    // 组件参数 接收来自父组件的数据
    props: {
        width: {
            type: Number,
            defaute: 0,
        },
        height: {
            type: Number,
            defaute: 0,
        },
        // 图片为base64格式的
        img: {
            type: String,
            required: true,
        },
    },
    // 局部注册的组件
    components: {
        VueCropper,
    },
    data() {
        return {
            show:false,
            base64_img:'',
            option: {
                img: "",                //裁剪图片的地址
                outputSize: 1,          //裁剪生成图片的质量(可选0.1 - 1)
                outputType: "jpeg",     //裁剪生成图片的格式（jpeg || png || webp）
                info: true,             //图片大小信息
                canScale: true,         //图片是否允许滚轮缩放
                autoCrop: true,         //是否默认生成截图框
                autoCropWidth: 230,     //默认生成截图框宽度
                autoCropHeight: 150,    //默认生成截图框高度
                fixed: false,           //是否开启截图框宽高固定比例
                fixedNumber: [1.53, 1], //截图框的宽高比例
                full: false,            //false按原比例裁切图片，不失真
                fixedBox: false,         //固定截图框大小，不允许改变
                canMove: true,          //上传图片是否可以移动
                canMoveBox: false,       //截图框能否拖动
                original: false,        //上传图片按照原始比例渲染
                centerBox: false,       //截图框是否被限制在图片里面
                high: true,             //根据dpr生成适合屏幕的高清图片
                height: true,           //是否按照设备的dpr 输出等比例图片
                infoTrue: false,        //true为展示真实输出图片宽高，false展示看到的截图框宽高
                // maxImgSize: 50,      //限制图片最大宽度和高度
                enlarge: 1,             //图片根据截图框输出比例倍数
                mode: "50% auto",       //图片默认渲染方式
            },
        };
    },
    created() {
        if(this.width == 0 && this.height == 0) {
            this.option.fixedBox = false;
        }else{
            this.option.fixedBox = true;
            this.option.autoCropWidth = this.width;
            this.option.autoCropHeight = this.height;
        }
        this.option.img = this.img;
    },
    methods: {
        // 预览
        realImg(){
            //获取截图的base64数据
            this.$refs.cropper.getCropData((data) => {
                this.base64_img = data;
                this.show = true;
            });
        },
        // 完成
        upload() {
            this.$refs.cropper.getCropData((data) => {
                this.$emit('upload',data);
            });
        },
        // 取消
        close() {
            this.$emit('close',false);
        },
    },
};
</script> 
<style scoped>
* {
    box-sizing: border-box;
}

.upload-img {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    z-index: 99;
}

.operation {
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    z-index: 1;
}

button {
    color: white;
    background: #1989fa;
    font-size: 0.3rem;
    padding: 0.1rem 0.2rem;
    border: none;
    margin-left: 0.04rem;
}

.crooper {
    width: 100%;
    height: 100%;
}

.overlay_img {
    width: 90%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}

.mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999999999;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.7);
}
</style>
